import { AxiosClient } from "./AxiosClient";
import { BASE_URL } from "./config";

// ─────────────────────────────────────────────────────────────────────────────
// CRUD
// ─────────────────────────────────────────────────────────────────────────────

export const createReport = async () => {
  try {
    const res = await AxiosClient.post("reports/create", { useCompany: true });
    return res;
  } catch (e) {
    console.error("createReport error:", e);
    return null;
  }
};

export const listReports = async () => {
  try {
    const res = await AxiosClient.get("reports/list", { useCompany: true });
    return res;
  } catch (e) {
    console.error("listReports error:", e);
    return null;
  }
};

export const getReport = async (reportId) => {
  try {
    const res = await AxiosClient.get("reports/get/" + reportId);
    return res;
  } catch (e) {
    console.error("getReport error:", e);
    return null;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const res = await AxiosClient.delete("reports/delete/" + reportId);
    return res;
  } catch (e) {
    console.error("deleteReport error:", e);
    return null;
  }
};

export const renameReport = async (reportId, title) => {
  try {
    const res = await AxiosClient.put("reports/rename/" + reportId, { title });
    return res;
  } catch (e) {
    console.error("renameReport error:", e);
    return null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Undo / Redo
// ─────────────────────────────────────────────────────────────────────────────

export const undoReport = async (reportId) => {
  try {
    const res = await AxiosClient.post("reports/undo", { report_id: reportId });
    return res;
  } catch (e) {
    console.error("undoReport error:", e);
    return null;
  }
};

export const redoReport = async (reportId) => {
  try {
    const res = await AxiosClient.post("reports/redo", { report_id: reportId });
    return res;
  } catch (e) {
    console.error("redoReport error:", e);
    return null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Streaming chat — uses raw fetch (axios doesn't support ReadableStream)
// ─────────────────────────────────────────────────────────────────────────────

export const streamReportChat = async ({
  reportId,
  message,
  userDatetime,
  signal,
}) => {
  try {
    const token = localStorage.getItem("user");
    const res = await fetch(BASE_URL + "reports/chat", {
      method: "POST",
      headers: {
        ...(token ? { "x-access-token": token } : {}),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        report_id: reportId,
        message,
        user_datetime: userDatetime,
      }),
      signal,
      useCompany: true,
    });
    return res;
  } catch (e) {
    if (e.name !== "AbortError") {
      console.error("streamReportChat error:", e);
    }
    return null;
  }
};
